module.exports = __webpack_public_path__ + "img/home_top.c4ac2b4d.jpg";